import Cookies from 'js-cookie'

export default {
  namespaced: true,
  state: {
    affiliateId: null,
    signInURL: `https://app.${process.env.VUE_APP_BASE_DOMAIN}/signin`,
    signUpURL: `https://app.${process.env.VUE_APP_BASE_DOMAIN}/signup`,
    modalDialog: {
      visible: false,
      count: 0
    },
    currentNavbar: null,
    currentNavbarTitle: '',
    pendingOrderCount: 0,
    newLeadsToday: 0,
    unitsSoldToday: 0,
    closedLeadsToday: 0,
    showSubscribeModal: false,
    lastIncomeTabPosition: 0,
    yezzapayMigrateModal: false,
    securepayMigrateModal: false,
    hasNewFeature: false
  },
  mutations: {
    setAffiliateId (state, afId) {
      if (afId) {
        state.affiliateId = afId
        state.signInURL = `https://app.${process.env.VUE_APP_BASE_DOMAIN}/signin?af_id=${afId}`
        state.signUpURL = `https://app.${process.env.VUE_APP_BASE_DOMAIN}/signup?af_id=${afId}`
      } else {
        state.affiliateId = null
        state.signInURL = `https://app.${process.env.VUE_APP_BASE_DOMAIN}/signin`
        state.signUpURL = `https://app.${process.env.VUE_APP_BASE_DOMAIN}/signup`
      }
    },
    setProject (state, project) {
      if (project) {
        state.signInURL = `https://app.${process.env.VUE_APP_BASE_DOMAIN}/signin?project=${project}`
        state.signUpURL = `https://app.${process.env.VUE_APP_BASE_DOMAIN}/signup?project=${project}`
      } else {
        state.signInURL = `https://app.${process.env.VUE_APP_BASE_DOMAIN}/signin`
        state.signUpURL = `https://app.${process.env.VUE_APP_BASE_DOMAIN}/signup`
      }
    },
    setRedirectPath (state, path) {
      let domain = `.${process.env.VUE_APP_BASE_DOMAIN}`
      if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
        domain = window.location.hostname
      }
      if (path) {
        Cookies.set('yz_next_path', path, { domain })
      } else {
        Cookies.remove('yz_next_path')
      }
    },
    setDialogVisibility (state, visible) {
      let currentCount = state.modalDialog.count
      if (visible) {
        currentCount += 1
      } else if (currentCount >= 1) {
        currentCount -= 1
      }
      state.modalDialog.count = currentCount
      if (state.modalDialog.count >= 1) {
        state.modalDialog.visible = true
      } else {
        state.modalDialog.visible = false
      }
    },
    setCurrentNavbar (state, navbar) {
      state.currentNavbar = navbar
      let domain = `.${process.env.VUE_APP_BASE_DOMAIN}`
      let secure = true
      if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
        domain = window.location.hostname
        secure = false
      }
      Cookies.set('yz_local_navbar', navbar, { secure, domain, expires: 90 })
    },
    setNavbarTitle (state, title) {
      state.currentNavbarTitle = title
    },
    setPendingOrderCount(state, count) {
      state.pendingOrderCount = count
    },
    setNewLeadsToday(state, count) {
      state.newLeadsToday = count
    },
    setUnitsSoldToday(state, count) {
      state.unitsSoldToday = count
    },
    setClosedLeadsToday(state, count) {
      state.closedLeadsToday = count
    },
    setShowSubscribeModal(state, show) {
      state.showSubscribeModal = show
    },
    setLastIncomeTabPosition(state, position) {
      state.lastIncomeTabPosition = position
      localStorage.setItem('yz_last_income_tab_position', position)
    },
    setYezzapayMigrateModal(state, status) {
      state.yezzapayMigrateModal = status
    },
    setSecurepayMigrateModal(state, status) {
      state.securepayMigrateModal = status
    },
    setHasNewFeature(state, status) {
      state.hasNewFeature = status
    }
  }
}
